import React from "react";
import FormContentLayout from "components/layout/FormContentLayout";
import { ContentProps } from "./types";

const UnactionableNonNeoBankContent: React.FC<ContentProps> = () => (
  <FormContentLayout
    heading="Unsupported bank."
    subheading={
      <>
        <p>
          We are not currently able to support the bank account you connected.
          This may be the case if you tried to connect a digital-only bank that
          does not have physical branches.
        </p>
        <p>
          If you have direct deposit set up with a different checking account,
          or you are able to switch your direct deposit to a different account,
          please{" "}
          <a href="mailto:hello@getreset.co?subject=Help with unsupported bank">
            email us
          </a>{" "}
          for assistance.
        </p>
      </>
    }
  />
);

export default UnactionableNonNeoBankContent;
